import { Injectable } from "@angular/core";
import { ApiService } from "./api";
import * as signalR from "@microsoft/signalr"

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LiveUpdateService {
  connection: signalR.HubConnection;
  persistentQueue: any[] = [];
  invokeQueue: any[] = [];

  constructor(
    private api: ApiService,
  ) {
    this.setupConnection();
  }

  async setupConnection() {
    if (!this.connection) {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(environment.clientService + "/LiveUpdatesHub", { withCredentials: false })
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: retryContext => {
                // If we've been reconnecting for less than 60 seconds so far,
                // wait between 0 and 5 seconds before the next reconnect attempt.
                return Math.random() * 5000;
          }
        })
        .configureLogging(signalR.LogLevel.Information)
        .build();

        
      this.connection.onreconnected(async () => {
        await this.applyPersistentInvokes();
      });
    }

    await this.start();
  }

  private async start() {
    try {
      await this.connection.start();

      this.persistentQueue.forEach(async invoke => {
        await this.invoke(invoke.methodName, false, ...invoke.args);
      });

      this.invokeQueue = [];
    } catch (err) {
      console.log(err);
      setTimeout(this.start, 5000);
    }
  }

  private async applyPersistentInvokes() {
    this.persistentQueue.forEach(async invoke => {
      await this.invoke(invoke.methodName, false, ...invoke.args);
    });
  }

  invoke<T = any>(methodName: string, persistent: boolean, ...args: any[]) {
    if (this.connection.state != signalR.HubConnectionState.Connected) {
      this.invokeQueue.push({ methodName: methodName, args: args });
      if (persistent) {
        this.persistentQueue.push({ methodName: methodName, args: args });
      }
    } else {
      return this.connection.invoke<T>(methodName, ...args);
    }
  }

  removePersistentInvoke(methodName: string) {
    this.persistentQueue = this.persistentQueue.filter(x => x.methodName != methodName);
  }

  on(methodName: string, newMethod: (...args: any[]) => any): void {
    this.connection.on(methodName, newMethod);
  }

  off_all(methodName: string): void {
    this.connection.off(methodName);
  }

  off(methodName: string, newMethod: (...args: any[]) => void): void {
    this.connection.off(methodName, newMethod);
  }
}